import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { HeaderService } from '../components/header/header.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ContactUsService } from "../contact-us/contact-us.service";
import { Payment } from '../_models/payment';
import { PriceService } from "./price.service";
import { environment } from '../../environments/environment';
import { DamserviceService } from "../dam/damservice.service";
import { SubscriptionService } from "../subscription/subscription.service";
import { Title, Meta } from '@angular/platform-browser';
import { AlertService } from "../components/alert/alert.service";
import { WindowRefService } from '../services/window-ref.service';
import { AuthService } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { OrganisationService } from "../create-organisation/organisation.service";
import AOS from 'aos';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {

  currentUser: User;

  priceDetailsSection: boolean = false;
  mainDetailSection: boolean = true;
  planUpgradeSection: boolean = false;
  hideFaq: boolean = true;
  paymentSuccessSection: boolean = false;
  headerSection: boolean = true;
  socialLoginSection: boolean = false;
  tellUsMoreSection: boolean = false;
  createWorkspaceSection: boolean = false;

  radioYearly: boolean = true;
  radioMonthly: boolean = false;
  detailsYearly: boolean = true;
  year: boolean = true;
  month: boolean = false;
  payNowButton: boolean = false;
  yearlyPlanValue: boolean = true;
  yearlyValue: boolean = true;
  loginModal: any;

  selectedMembership: any = null;
  selectedMembershipBuyNow: any = null;
  payment: Payment;
  public isIndia: boolean = false;
  private monthAmount: string;
  private yearAmount: string;
  @ViewChild('paymentSuccess') paymentSuccess;
  paymentSuccessModal: any;
  address: string = '124 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';
  returnUrl: any;
  newAmount: string;
  totalUsers: string;
  addUserCount: any;
  allowedInviteCount: any;
  isCustomPlan: boolean = false;
  strikeCheckout:any = null;
  memberships = [];
  membershipPlan = [];
  userName: string;
  userEmail: string;
  companyName: string;

  showMaxSeatsReached: boolean = false;
  showGoogleLoginLoader: boolean = false;
  showSeatsErrorText: string;
  addStartUserCount: any;
  pricePerUser: any;

  orderId: any;
  totalRazorAmount: any;
  userRazorPayName: string;
  razorPayKey: string;
  isShowError: boolean = false;
  upgradingSeatsProcessStyle = "none";
  planUpGradePrice: any;
  totalPriceFixedPlanUpgrade: any;
  public isIndiaProrata: boolean = true;

  timeSelected: boolean = false;
  dateSelected: boolean = false;
  showTime: boolean = false;
  showFinalTime: boolean = false;
  showSubmitBtn: boolean = false;
  shownTime: string;
  showDate: boolean = true;
  shownDate: string;
  shownMonth: string;
  shownDay: string;
  availableTimeSlots = [];
  availableSlots = [];
  selectedTime: any;
  selectedDate: any;
  thankYouText: string = "Thank you, select date for a quick call.";
  showSelectedMsg: string;
  date: string;
  time: string;

  showCouponField: boolean = false;
  couponcode: any;
  totalHikedPrice: any;
  couponBtnText: any = "Apply";
  showCouponCodeError: boolean = false;
  couponCodeErrorMsg: any;
  totalPriceFixed: any;

  isDateSelected: boolean = false;
  isTimeSelected: boolean = false;
  showSelectionMessage: boolean = false;
  showLeaveLoader: boolean = false;
  // showLoginLoader: boolean = false;

  isShowCreateWorkspaceError: boolean = false;
  createWorkspaceErrorMessage: any;
  createWorkspaceLoginErrorMessage: string;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  sendingProcessStyle = "none";

  login: boolean = true;
  emailVerify: boolean = false;
  signup: boolean = false;
  forgotpassword: boolean = false;
  forgotpasswordFields: boolean = false;
  enterOtp: boolean = false;
  resetPassword: boolean = false;

  submitted: Boolean = false;
  submitt: Boolean = false;
  submittedForm: Boolean = false;
  submittion: Boolean = false;
  emailVerifySubmit: Boolean = false;
  passwordSubmit: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;
  workspace_token: string;
  emailId: string;
  emailIds: string;
  forgotPasswordErrorMsg: string;
  loginErrorMsg: string;
  selectRoleTitle: string = "Founder";
  showSending: boolean = false;
  showSendingSmall: boolean = false;
  showTellUsLoader: boolean = false;
  tellUsMoreSectionErrorMsg: any;
  showTellUsMoreSectionError: boolean = false;
  signUpFormFilled: boolean = false;
  fromScreen: any;
  screenToken: any;

  sendSuccessfulMsg: boolean = false;
  successfullMessage: string;
  showTopRightLoader: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;

  public lat;
  public lng;

  loginForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    password: ['', Validators.required],
  });

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  enterOtpForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  emailVerifyForm = this.fb.group({
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  signUpForm = this.fb.group({
    fname: ['', Validators.required],
    lname: ['', Validators.required],
    password: ['', Validators.required],
    otp: ['', Validators.required],
  });

  resetPasswordForm = this.fb.group({
    otp: ['', Validators.required],
    password: ['', Validators.required],
    repassword: ['', Validators.required],
  });

  enterNewDetails = this.fb.group({
    organization: [''],
    phoneNumber: [''],
    roleTitle: [''],
  });


  letsTalkForm = this.fb.group({
    name: ['', Validators.required],
    lname: ['', Validators.required],
    message: ['Enterprise plan query Pricing page DAM(Outside Pricing)', Validators.required],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    company: ['', Validators.required],
  });

  @ViewChild('letsTalk') letsTalk;
  @ViewChild('selectDate') selectDate;
  @ViewChild('showloader') showloader;
  @ViewChild('thankyou') thankyou;

  constructor(
    private reCaptchaV3Service: ReCaptchaV3Service,
    private fb: FormBuilder,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private headerService: HeaderService,
    private cdr: ChangeDetectorRef,
    private contacUsService: ContactUsService,
    private priceService: PriceService,
    private damService: DamserviceService,
    private subscriptionService: SubscriptionService,
    private titleService: Title,
    private metaTagService: Meta,
    private alert: AlertService,
    private winRef: WindowRefService,
    private authService: AuthService,
    private organisationService: OrganisationService,
  ) { }

  public siteKey?: string = '6Lf59_gUAAAAAEJNHrHp1Vdd1LaG1epuOF62yj80';
  public token?: string;
  public siteKeyV2: string = "6Lf4BvkUAAAAAKreyepy8vMm4ttzZtXIY_0xVJ0O";
  type: string = "checkbox";

  ngOnInit(): void {
    this.titleService.setTitle("Pricing of plans | Workspace | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Pricing of plans is based on their storage space and invites.'},
      { name: 'keywords', content: 'pricing workspace, subscription workspace, checkout, workspace plan price, price plan' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    this.authService.authState.subscribe((user) => {
      if (user && !this.authenticationService.currentUserValue) {
        this.loginToServer(user, user.photoUrl, this.workspace_token);
      }
    });

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (this.currentUser) {
      this.payNowButton = true;
    }else{
      this.payNowButton = false;
    }

    this.getDamPlans();
    this.getLocation();
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  showPayment(membership: any) {
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.priceDetailsSection = true;
      this.mainDetailSection = false;
      this.planUpgradeSection = false;
      this.selectedMembership = membership;
    } else {
      this.headerService.setLoginModalValue(true);
    }
  }

  showMainSection() {
    window.scrollTo(0, 0);
    this.showMaxSeatsReached = false;
    this.priceDetailsSection = false;
    this.mainDetailSection = true;
    this.planUpgradeSection = false;
    this.hideFaq = false;
    this.headerSection = true;
    this.paymentSuccessSection = false;
    this.socialLoginSection = false;
    this.tellUsMoreSection = false;
    this.signUpFormFilled = false;
    this.createWorkspaceSection = false;
  }

  openLetsTalkDialog(modal){
      this.letsTalk = this.modalService.open(modal, { centered: true, windowClass: 'sign-up ' });
  }

  openSelectTimeDialog(modal){
      this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
  }

  openThankskDialog(modal){
      this.thankyou = this.modalService.open(modal, { centered: true, windowClass: 'thanks-popup ' });
  }

  openLoginOrDam(){
    if(this.currentUser){
      this.router.navigate(['/dam']);
    }else{
      this.router.navigate(['/login']);
    }
  }

  openLoginModal(membership: any){
    if(this.currentUser){
      window.scrollTo(0, 0);
      this.mainDetailSection = false;
      this.priceDetailsSection = true;
      this.planUpgradeSection = false;
      this.hideFaq = false;
      this.selectedMembership = membership;
      this.addUserCount = this.selectedMembership.allowed_seats;
      this.allowedInviteCount = this.selectedMembership.allowed_seats;
      this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
      // this.router.navigate(['/dam/subscription']);
    }else{
      this.selectedMembership = membership;
      this.headerSection = false;
      this.tellUsMoreSection = false;
      this.signUpFormFilled = false;
      this.priceDetailsSection = false;
      this.mainDetailSection = false;
      this.planUpgradeSection = false;
      this.hideFaq = false;
      this.paymentSuccessSection = false;
      this.socialLoginSection = true;
    }
  }

  userCountHike(addUserCount: any, totalPriceFixe: any, selectedMembership: any) {
    if(selectedMembership.title == 'Plus') {
      this.addStartUserCount = addUserCount+1;
      this.couponcode = "";
      this.couponBtnText = "Apply";
      if(this.addStartUserCount < this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.addStartUserCount;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
      } else if(this.addStartUserCount == this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.addStartUserCount;;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
        this.showMaxSeatsReached = true;
        this.showSeatsErrorText = "Max " + this.selectedMembership.max_allowed_seats +" seats allowed in this plan.";
      }
    } else if(selectedMembership.title == 'Professional') {
      this.addStartUserCount = addUserCount+1;
      this.couponcode = "";
      this.couponBtnText = "Apply";
      if(this.addStartUserCount < this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.addStartUserCount;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
      } else if(this.addStartUserCount == this.selectedMembership.max_allowed_seats) {
        this.addUserCount = this.selectedMembership.max_allowed_seats;
        this.isCustomPlan = true;
        this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
        this.totalPriceFixed = this.selectedMembership.price_yearly*12
        this.totalPriceFixed = this.addStartUserCount*this.pricePerUser;
        this.showMaxSeatsReached = true;
        this.showSeatsErrorText = "Max " + this.selectedMembership.max_allowed_seats +" seats allowed in this plan.";
      }
    }
    // this.totalUsers = this.allowedInviteCount + this.addUserCount;
  }

  userCountDike(addUserCount: any, totalPriceFixe: any, selectedMembership: any) {
    if(addUserCount == this.allowedInviteCount) {
      this.showMaxSeatsReached = false;
      this.addUserCount = this.allowedInviteCount;
      this.couponcode = "";
      this.isCustomPlan = false;
      this.pricePerUser = this.selectedMembership.price_per_user*this.addUserCount;
      this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.allowedInviteCount;
    } else {
      this.showMaxSeatsReached = false;
      this.addUserCount = addUserCount-1;
      this.isCustomPlan = true;
      // this.totalUsers = this.allowedInviteCount + this.addUserCount;
      this.pricePerUser = (this.selectedMembership.price_per_user/100)*100;
      // this.totalPriceFixed = this.selectedMembership.price_yearly*12;
      if(this.couponBtnText == 'Remove') {
        this.totalPriceFixed = this.totalHikedPrice-this.pricePerUser;
        this.couponBtnText = "Apply";
      } else {
        this.totalPriceFixed = this.totalPriceFixed-this.pricePerUser;
      }
      this.couponcode = "";
    }
  }

  openPriceLoginModal(membership: any){
    if(this.currentUser){
      window.scrollTo(0, 0);
      this.mainDetailSection = false;
      this.priceDetailsSection = true;
      this.planUpgradeSection = false;
      this.selectedMembership = membership;
    }else{
      this.router.navigate(['/login']);
    }
  }

  public submitContactUs(modal) {
    this.submitted = true;
    if (this.letsTalkForm.valid) {
      this.showLeaveLoader = true;
      this.reCaptchaV3Service.execute(this.siteKey, 'contact_us', (token) => {
        this.letsTalkForm.value['recaptcha'] = token;
        this.cdr.detectChanges();
        this.userName = this.letsTalkForm.value['name'] +" "+this.letsTalkForm.value['lname'];
        this.userEmail = this.letsTalkForm.value['email'];
        this.companyName = this.letsTalkForm.value['company'] +" : " +this.letsTalkForm.value['message'];
        this.date = this.letsTalkForm.value['date'];
        this.time = this.letsTalkForm.value['time_start'];
        this.letsTalkForm.reset()
        this.letsTalk.close();
        this.showLeaveLoader = false;
        this.getDateListApi();
        this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
      });
    }
  }

  getDateListApi() {
    this.subscriptionService.getDateCall().subscribe((data: any) => {
      this.availableSlots = data;
      this.getTimeListApi(data[0].date);
    });
  }

  getTimeListApi(date: any) {
    this.subscriptionService.getTimeCall(date).subscribe((data: any) => {
      this.availableTimeSlots = data;
    });
  }

  contactSalesCall(modal) {
    if(this.isDateSelected == true && this.isTimeSelected == true) {
      this.sendingProcessStyle = "block";
      this.showLeaveLoader = true;
       this.subscriptionService.contactSalesCallApi(this.userName, this.userEmail, this.companyName,
         this.selectedDate, this.selectedTime).subscribe((data) => {
         this.showLeaveLoader = false;
         this.submitted = false;
         this.sendingProcessStyle = "none";
         this.openThankskDialog(modal);
       },(error: any) => {
         if(error.status == 400){
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunction();
         } else {
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunction();
         }
      });
    } else if(this.isDateSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Date";
    } else if(this.isTimeSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Time";
    }
  }

  selectDateSales(date: string, day: string, month: string) {
    this.selectedDate = date;
    this.showDate = false;
    this.isDateSelected = true;
    this.dateSelected = true;
    this.showSubmitBtn = true;
    this.showSelectionMessage = false;
    this.thankYouText = "Thank You!! select time."

    this.getTimeListApi(date);
    this.showTime = true;
    this.timeSelected = false;
    this.showFinalTime = false;

    this.shownMonth = month;
    if(day == 'Mon') {
      this.shownDay = "Monday";
    } else if(day == 'Tue') {
      this.shownDay = "Tuesday";
    } else if(day == 'Wed') {
      this.shownDay = "Wednesday";
    } else if(day == 'Thu') {
      this.shownDay = "Thursday";
    } else if(day == 'Fri') {
      this.shownDay = "Friday";
    } else if(day == 'Sat') {
      this.shownDay = "Saturday";
    } else if(day == 'Sun') {
      this.shownDay = "Sunday";
    }

    let stringToSplit = this.selectedDate;
    let splitDate = stringToSplit.split("-");

    if(splitDate[1] == '01') {
      this.shownDate = "Jan" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '02') {
      this.shownDate = "Feb" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '03') {
      this.shownDate = "March" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '04') {
      this.shownDate = "April" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '05') {
      this.shownDate = "May" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '06') {
      this.shownDate = "June" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '07') {
      this.shownDate = "Julu" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '08') {
      this.shownDate = "Aug" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '09') {
      this.shownDate = "Sept" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '10') {
      this.shownDate = "Oct" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '11') {
      this.shownDate = "Nov" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '12') {
      this.shownDate = "Dec" +" "+ splitDate[2] +", "+splitDate[0];
    }
  }

  changeDate() {
    this.showDate = true;
    this.isDateSelected = false;
    this.dateSelected = false;
    this.showSubmitBtn = false;
    this.showSelectionMessage = false;
    this.showTime = false;
    this.isTimeSelected = false;
    this.timeSelected = false;
    this.showFinalTime = false;
    // this.getTimeListApi(this.availableSlots[0].date);
  }

  selectTimeSales(time) {
    this.selectedTime = time;
    this.showTime = false;
    this.showSubmitBtn = true;
    this.shownTime = time;
    this.showFinalTime = true;
    this.isTimeSelected = true;
    this.showSelectionMessage = false;
    this.timeSelected = true;
    this.thankYouText = "Thank You!! you meeting will be scheduled."
  }

  changeTime() {
    this.showTime = true;
    this.isTimeSelected = false;
    this.timeSelected = false;
    this.showSelectionMessage = false;
  }

  getDamPlans(){
    this.priceService.getDamPlans().subscribe((data: any) => {
      this.memberships = data;
      this.membershipPlan = data;
    });
  }

  yearly(){
    this.yearlyPlanValue = true;
    this.memberships = this.memberships;
  }
  monthly(){
    this.yearlyPlanValue = false;
    this.memberships = this.memberships;
  }

  yearlyPlan(){
    this.yearlyValue = true;
    this.membershipPlan = this.memberships;
  }
  monthlyPlan(){
    this.yearlyValue = false;
    this.membershipPlan = this.memberships;
  }

    checkoutStripe(amount, currency, membership) {
      const strikeCheckout = (<any>window).StripeCheckout.configure({
        key: environment.STRIPE_LIVE_KEY,
        locale: 'auto',
        token: (stripeToken: any) => {
          // console.log(stripeToken)
          this.subscriptionService.postStripeOrder(stripeToken, amount, currency,
            membership.id, this.currentUser.firstName+" "+ this.currentUser.lastName,
            this.address, this.city, this.state, this.country, this.postcode,
            this.totalPriceFixed, this.addUserCount, this.isCustomPlan, this.couponcode).subscribe((data) => {
              this.mainDetailSection = false;
              this.priceDetailsSection = false;
              this.planUpgradeSection = false;
              this.hideFaq = false;
              this.paymentSuccessSection = true;
          });
        }
      });

      strikeCheckout.open({
        name: 'Crafttor',
        description: 'Stripe Payment Gateway',
        image: 'https://crafttor.com/crafttor.jpg',
        currency: currency,
        amount: this.totalPriceFixed * 100
      });
    }

  stripePaymentGateway() {
    if(!window.document.getElementById('stripe-script')) {
      const scr = window.document.createElement("script");
      scr.id = "stripe-script";
      scr.type = "text/javascript";
      scr.src = "https://checkout.stripe.com/checkout.js";

      scr.onload = () => {
        this.strikeCheckout = (<any>window).StripeCheckout.configure({
          key: environment.STRIPE_LIVE_KEY,
          locale: 'auto',
          token: function (token: any) {
          console.log(token)
          alert('Payment via stripe successfull!');
          }
        });
      }
      window.document.body.appendChild(scr);
      }
    }

    chooseYearly(){
      this.radioMonthly=false;
      this.radioYearly=true;
    }

    openMarketplace() {
      window.open("https://crafttor.com/marketplace", "_blank");
    }

    showCouponFieldClick() {
      this.showCouponField = true;
    }

    applyCouponCode() {
      if(this.couponcode == 'SEASON50' || this.couponcode == 'season50'){
        this.showCouponCodeError = false;
        this.couponCodeErrorMsg = "";
        if(this.couponBtnText == 'Apply') {
          this.totalHikedPrice = this.totalPriceFixed;
          this.totalPriceFixed = this.totalPriceFixed/2;
          this.couponBtnText = "Remove";
        } else if (this.couponBtnText == 'Remove') {
          this.totalPriceFixed = this.totalPriceFixed*2;
          this.couponBtnText = "Apply";
          this.couponcode = "";
        }
      } else {
        this.showCouponCodeError = true;
        this.couponCodeErrorMsg = "Invalid coupon";
      }
    }

    switchToWorkspace(){
      window.scrollTo(0, 0);
      // this.selectedMembershipBuyNow = membership;
      if (this.currentUser) {
        this.router.navigate(['/dam']);
      }
    }

    getCurrentPlanDetails(membership: any) {
      // if(this.planName == 'Plus') {
        if (this.currentUser) {
          if(this.isIndiaProrata == true) {
            this.upgradeOldPlanWithNewRazor(membership.id);
            this.titleService.setTitle("Checkout | Workspace | Crafttor");
            this.selectedMembership = membership;
            this.totalPriceFixed = this.selectedMembership.price_yearly*12;
            this.addUserCount = this.selectedMembership.allowed_seats;
            this.allowedInviteCount = this.selectedMembership.allowed_seats;
            this.mainDetailSection = false;
            this.hideFaq = false;
            this.paymentSuccessSection = false;
            this.priceDetailsSection = false;
            this.planUpgradeSection = true;
            window.scrollTo(0, 0);
          } else {
            this.upgradeOldPlanWithNew(membership.id);
            this.titleService.setTitle("Checkout | Workspace | Crafttor");
            this.selectedMembership = membership;
            this.totalPriceFixed = this.selectedMembership.price_yearly*12;
            this.addUserCount = this.selectedMembership.allowed_seats;
            this.allowedInviteCount = this.selectedMembership.allowed_seats;
            this.mainDetailSection = false;
            this.hideFaq = false;
            this.paymentSuccessSection = false;
            this.priceDetailsSection = false;
            this.planUpgradeSection = true;
            window.scrollTo(0, 0);
          }
        }
      // } else {
      //   this.showPayment(membership);
      // }
    }

    createRzpayOrderUpgrade(amount: any, currency: any, membership: any) {
     //  this.userRazorPayName = this.currentUser.firstName+" "+ this.currentUser.lastName;
     //  this.damService.getUpgradeSeatAmountRazor(membership.id, this.extraSeatsUserCount).subscribe((data: any) => {
     //    this.orderId = data.razorpay_order_id;
     //    this.totalRazorAmount = data.razorpay_amount;
     //    this.razorPayKey = data.razorpay_merchant_key;
     //    this.payWithRazorProrata(this.orderId, this.razorPayKey, this.totalRazorAmount,
     //      this.userRazorPayName, membership.id, this.totalPriceFixed, this.addUserCount);
     //  },(error: any) => {
     //    if(error.status == 400){
     //      this.alert.error(error.error.message)
     //    } else {
     //      this.alert.error(error.error.message)
     //    }
     // });
    }

    userPlanUpgradeCountHikeRazor(addUserCount: any, totalPriceFixe: any) {
      // this.addTotalUserCount = addUserCount+1;
      // this.totalUsers = this.allowedInviteCount;
      // this.extraSeatsUserCount = this.addTotalUserCount - this.totalUsers;
      // this.isCustomPlan = true;
      // this.getSeatAmountApiRazor(this.extraSeatsUserCount, addUserCount+1);
    }

    userPlanUpgradeCountDikeRazor(addUserCount: any, totalPriceFixe: any) {
      // if(addUserCount == this.allowedInviteCount) {
      //   this.addUserCount = this.allowedInviteCount;
      //   this.totalUsers = this.allowedInviteCount;
      //   this.isCustomPlan = false;
      //   this.extraSeatsUserCount = this.allowedInviteCount;
      //   // this.getSeatAmountApiRazor(this.extraSeatsUserCount, this.addUserCount);
      // } else {
      //   this.addTotalUserCount = addUserCount-1;
      //   this.isCustomPlan = true;
      //   this.totalUsers = this.allowedInviteCount;
      //   this.extraSeatsUserCount = this.addTotalUserCount - this.totalUsers;
      //   this.getSeatAmountApiRazor(this.extraSeatsUserCount, addUserCount-1);
      // }
    }

    showPaymentPage(amount: any, currency: any, membership: any) {
      localStorage.setItem('priceDetails', JSON.stringify({ chargeAmount: amount, chargeCurrency: currency,
        chargeMembership: membership }));
      // this.router.navigate(['/dam/payment']);
    }

    upgradeOldPlanWithNew(planId: any) {
      this.isShowError = false;
      this.upgradingSeatsProcessStyle = "block";
      this.subscriptionService.getUpgradePlanDetails(planId).subscribe((data: any) => {
        this.isShowError = false;
        this.planUpGradePrice = data.total_new_amount_to_be_paid;
        this.totalPriceFixedPlanUpgrade = data.total_new_amount_to_be_paid;
        this.upgradingSeatsProcessStyle = "none";
      },(error: any) => {
        this.upgradingSeatsProcessStyle = "none";
        if(error.status == 400){
          this.isShowError = true;
        } else {
          this.isShowError = true;
        }
     });
    }

    upgradeOldPlanWithNewRazor(planId: any) {
      this.isShowError = false;
      this.upgradingSeatsProcessStyle = "block";
      this.subscriptionService.getUpgradePlanDetailsRazor(planId).subscribe((data: any) => {
        this.isShowError = false;
        this.planUpGradePrice = data.total_new_amount_to_be_paid;
        this.totalPriceFixedPlanUpgrade = data.total_new_amount_to_be_paid;
        this.upgradingSeatsProcessStyle = "none";
      },(error: any) => {
        this.upgradingSeatsProcessStyle = "none";
        if(error.status == 400){
          this.isShowError = true;
        } else {
          this.isShowError = true;
        }
     });
    }

    createRzpayOrder(amount: any, currency: any, membership: any) {
      this.userRazorPayName = this.currentUser.firstName+" "+ this.currentUser.lastName;
      this.subscriptionService.getRazorOrderId(this.userRazorPayName, this.totalPriceFixed,
        currency, membership.id, this.isCustomPlan, this.addUserCount, this.couponcode).subscribe((data: any) => {
        this.orderId = data.razorpay_order_id;
        this.totalRazorAmount = data.razorpay_amount;
        this.razorPayKey = data.razorpay_merchant_key;
        this.payWithRazor(this.orderId, this.razorPayKey, this.totalRazorAmount,
          this.userRazorPayName, membership.id, this.totalPriceFixed,
          this.addUserCount, this.couponcode);
      },(error: any) => {
        if(error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunction();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunction();
        }
     });
    }

    payWithRazor(val: any, key: any, totalAmount: any, userName: any,
      planId: any, totalValue: any, totalSeats: any, couponCode: any) {
      localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: totalAmount}));
      const options: any = {
        key: key,
        amount: totalAmount*100,
        currency: 'USD',
        name: 'Crafttor', // company name or product name
        description: '',  // product description
        image: 'https://crafttor.com/crafttor.jpg', // company logo or product image
        order_id: val, // order_id created by you in backend
        modal: {
          // We should prevent closing of the form when esc key is pressed.
          escape: false,
        },
        notes: {
          // include notes if any
        },
        theme: {
          color: '#0c238a'
        }
      };
      options.handler = ((response, error) => {
        options.response = response;
        this.subscriptionService.payRazorAmountOrderId(response.razorpay_payment_id,
          response.razorpay_order_id,response.razorpay_signature, userName, planId,
          totalValue, totalSeats, this.isCustomPlan, this.couponcode).subscribe((data: any) => {
            this.router.navigate(['/pricing']);
        },(error: any) => {
          if(error.status == 400){
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunction();
          } else {
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunction();
          }
       });
      });
      options.modal.ondismiss = (() => {
        // handle the case when user closes the form while transaction is in progress
        console.log('Transaction cancelled.');
      });
      const rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
      // this.hideSuccesfullFunctionMsg();
    }

    signInWithGoogle(): void {
      if(this.currentUser){
        this.logOut();
        this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
      }else{
        this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
      }
    }

    logOut(): void {
      this.authenticationService.logout();
      this.authService.signOut();
      this.router.navigate(['/login']);
    }

    loginToServer(user: any = null, photoUrl: string, workspace_token: string) {
      this.showGoogleLoginLoader = true;
      this.authenticationService.login(user.provider.toLowerCase(), user.id,
      user.authToken, user.email, user.firstName, user.lastName,
      photoUrl, this.lat, this.lng, workspace_token)
        .subscribe(
          (_data) => {
            this.listWorkspace();
            this.showGoogleLoginLoader = false;
          },
          (error) => {
            if(error.status == 400){
              this.showGoogleLoginLoader = false;
              this.alert.error("Oops!! Something went wrong.");
              // this.router.navigate(['/maintenance']);
            } else {
              this.showGoogleLoginLoader = false;
              this.socialLoginSection = false;
              this.tellUsMoreSection = false;
              this.signUpFormFilled = false;
              this.headerSection = true;
              this.priceDetailsSection = true;
              this.addUserCount = this.selectedMembership.allowed_seats;
              this.allowedInviteCount = this.selectedMembership.allowed_seats;
              this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
            }
        });
    }

    loginFunction(){
      this.submitted = true;
      this.loginErrorMsg = "";
      if (this.loginForm.valid) {
        this.showSendingSmall = true;
        this.showLeaveLoader = true;
          this.authenticationService.loginWithEmail(this.loginForm.value.email, this.loginForm.value.password, this.workspace_token).subscribe((data) => {
            this.showLeaveLoader = false;
            this.showSendingSmall = false;
            this.submitted = false;
            this.loginForm.reset();
            this.socialLoginSection = false;
            this.tellUsMoreSection = false;
            this.signUpFormFilled = false;
            this.headerSection = true;
            this.priceDetailsSection = true;
            this.addUserCount = this.selectedMembership.allowed_seats;
            this.allowedInviteCount = this.selectedMembership.allowed_seats;
            this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
          },
          (error) => {
            const errors = error.error || error.statusText;
            Object.keys(errors).map((key) => {
              errors[key].map((message) => {
                this.loginErrorMsg = message;
                this.submitted = false;
                this.showLeaveLoader = false;
                this.showSendingSmall = false;
              })
            })
         })
      }
    }

    signUpNextFuntion() {
      if (this.signUpForm.valid) {
        this.showSending = false;
        this.showSendingSmall = false;
        this.socialLoginSection = false;
        this.tellUsMoreSection = true;
        this.login = false;
        this.emailVerify = false;
        this.forgotpassword = false;
        this.forgotpasswordFields = false;
        this.enterOtp = false;
        this.resetPassword = false;
        this.signup = false;
        this.emailVerifySubmit = false;
        this.signUpFormFilled = true;
      }
    }

    signUpBackFuntion() {
      this.showSending = false;
      this.showSendingSmall = false;
      this.socialLoginSection = true;
      this.tellUsMoreSection = false;
      this.login = false;
      this.emailVerify = false;
      this.forgotpassword = false;
      this.forgotpasswordFields = false;
      this.enterOtp = false;
      this.resetPassword = false;
      this.signup = true;
      this.emailVerifySubmit = false;
    }

    signUpFormFunction(){
      this.submitt = true;
      if (this.signUpFormFilled) {
        this.showSendingSmall = true;
        this.showTellUsLoader = true;
        this.showTellUsMoreSectionError = false;
        this.authenticationService.registerWithEmail(this.signUpForm.value.fname,
          this.signUpForm.value.lname, this.emailIds,
          this.signUpForm.value.password, this.signUpForm.value.otp,
          this.enterNewDetails.value.organization, this.enterNewDetails.value.phoneNumber,
          this.selectRoleTitle, this.lat, this.lng, this.workspace_token)
          .subscribe(
            (_data) => {
              this.submitt = false;
              this.showLeaveLoader = false;
              this.showTellUsLoader = false;
              this.showSendingSmall = false;
              this.signUpForm.reset();
              this.enterNewDetails.reset();
              // this.showLoginLoader = true;
              this.listWorkspace();
          },
            (error) => {
              const errors = error.error || error.statusText;
              Object.keys(errors).map((key) => {
                errors[key].map((message) => {
                  this.showTellUsMoreSectionError = true;
                  this.tellUsMoreSectionErrorMsg = message;
                  this.submitt = false;
                  this.showTellUsLoader = false;
                  this.showLeaveLoader = false;
                  this.showSendingSmall = false;
                  this.hideSuccesfullFunction();
                })
              })
           });
      }
    }

    hideSuccesfullFunction(){
      setTimeout(() => {
        this.sendSuccessfulMsg = false;
        this.sendSuccessfulErrorMsg = false;
        this.showTellUsMoreSectionError = false;
        this.submitt = false;
        this.showTellUsLoader = false;
        this.showLeaveLoader = false;
        this.showSendingSmall = false;
      }, 3000);
    }

    resendOTP() {
      this.sendOTPFunction();
    }

    getOTP(){
      this.emailVerifySubmit = true;
      this.emailIds = this.emailVerifyForm.value.email
      if (this.emailVerifyForm.valid) {
        this.showSendingSmall = true;
        this.showLeaveLoader = true;
        this.sendOTPFunction();
      }
    }

    sendOTPFunction() {
      this.damService.getOTP(this.emailVerifyForm.value.email).subscribe((data: any) => {
        this.sendSuccessfulMsg = true;
        this.successfullMessage = "OTP sent Successfully!";
        this.hideSuccesfullFunction();
        this.showSendingSmall = false;
        this.showLeaveLoader = false;
        this.emailVerifyForm.reset()
        this.login = false;
        this.emailVerify = false;
        this.forgotpassword = false;
        this.forgotpasswordFields = false;
        this.enterOtp = false;
        this.resetPassword = false;
        this.signup = true;
        this.emailVerifySubmit = false;
      },
      (error) => {
        const errors = error.error || error.statusText;
        Object.keys(errors).map((key) => {
          errors[key].map((message) => {
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunction();
              this.emailVerifySubmit = false;
              this.showLeaveLoader = false;
              this.showSendingSmall = false;
          })
        })
      });
    }

    forgotPasswordFunction(){
      this.submittedForm = true;
      if (this.forgotPasswordForm.valid) {
        this.showSendingSmall = true;
        this.showLeaveLoader = true;
        this.damService.getResetPasswordOTP(this.forgotPasswordForm.value.email).subscribe((data: any) => {
          this.sendSuccessfulMsg = true;
          this.successfullMessage = "OTP sent Successfully!";
          this.hideSuccesfullFunction();
          this.showSendingSmall = false;
          this.showLeaveLoader = false;
          this.login = false;
          this.signup = false;
          this.forgotpassword = false;
          this.enterOtp = true;
          this.resetPassword = true;
          this.submittedForm = false;
        },
        (error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            // console.log("finally revealed" + errors[key]);
            errors[key].map((message) => {
              this.forgotPasswordErrorMsg = message;
              this.submittedForm = false;
              this.showLeaveLoader = false;
              this.showSendingSmall = false;
            })
          })
       });
      }
    }

    resetPasswordFunction(){
      this.passwordSubmit = true;
        if (this.enterOtpForm.valid) {
          this.showSendingSmall = true;
          this.showLeaveLoader = true;
          this.damService.resetPassword(this.forgotPasswordForm.value.email, this.enterOtpForm.value.otp,
            this.enterOtpForm.value.password, this.enterOtpForm.value.repassword).subscribe((data: any) => {
              this.sendSuccessfulMsg = true;
              this.successfullMessage = "Password reset Successfully!";
              this.hideSuccesfullFunction();
              this.showSendingSmall = false;
              this.showLeaveLoader = false;
              this.passwordSubmit = false;
              this.enterOtpForm.reset()
              this.forgotPasswordForm.reset()
              this.login = true;
              this.signup = false;
              this.forgotpassword = false;
              this.enterOtp = false;
              this.resetPassword = false;
            },
            (error) => {
              const errors = error.error || error.statusText;
              Object.keys(errors).map((key) => {
                // console.log("finally revealed" + errors[key]);
                errors[key].map((message) => {
                  this.sendSuccessfulErrorMsg = true;
                  this.sendSuccessfulErrorMessage = error.error.message;
                  this.hideSuccesfullFunction();
                  this.passwordSubmit = false;
                  this.showLeaveLoader = false;
                  this.showSendingSmall = false;
                })
              })
          });
        }
      }

      showLoginScreen() {
        this.loginErrorMsg = "";
        this.showLeaveLoader = false;
        this.forgotpassword = false;
        this.forgotpasswordFields = false;
        this.enterOtp = false;
        this.resetPassword = false;
        this.signup = false;
        this.emailVerify = false;
        this.passwordSubmit = false;
        this.submittedForm = false;
        this.emailVerifySubmit = false;
        this.submitt = false;
        this.submitted = false;
        this.login = true;
      }

      showEmailVerifyScreen() {
        this.loginErrorMsg = "";
        this.showLeaveLoader = false;
        this.login = false;
        this.forgotpassword = false;
        this.forgotpasswordFields = false;
        this.enterOtp = false;
        this.resetPassword = false;
        this.signup = false;
        this.passwordSubmit = false;
        this.submittedForm = false;
        this.emailVerifySubmit = false;
        this.submitt = false;
        this.submitted = false;
        this.emailVerify = true;
      }

      showSignUpScreen() {
        this.loginErrorMsg = "";
        this.showLeaveLoader = false;
        this.login = false;
        this.forgotpassword = false;
        this.forgotpasswordFields = false;
        this.enterOtp = false;
        this.resetPassword = false;
        this.emailVerify = false;
        this.passwordSubmit = false;
        this.submittedForm = false;
        this.emailVerifySubmit = false;
        this.submitt = false;
        this.submitted = false;
        this.signup = true;
      }

      forgotScreen(){
        this.loginErrorMsg = "";
        this.showLeaveLoader = false;
        this.loginForm.reset();
        this.login = false;
        this.enterOtp = false;
        this.resetPassword = false;
        this.signup = false;
        this.emailVerify = false;
        this.forgotpasswordFields = false;
        this.passwordSubmit = false;
        this.submittedForm = false;
        this.emailVerifySubmit = false;
        this.submitt = false;
        this.submitted = false;
        this.forgotpassword = true;
      }

      showResetPasswordScreen() {
        this.showLeaveLoader = false;
        this.login = false;
        this.forgotpassword = false;
        this.forgotpasswordFields = false;
        this.enterOtp = false;
        this.emailVerify = false;
        this.signup = false;
        this.passwordSubmit = false;
        this.submittedForm = false;
        this.emailVerifySubmit = false;
        this.submitt = false;
        this.submitted = false;
        this.resetPassword = true;
      }

      selectedRoleTitle(event: any) {
        this.selectRoleTitle = event.target.value;
      }

      listingWorkspace() {
        if(this.currentUser) {
          this.organisationService.getWorkspaceList().subscribe((data: any) => {
            this.showSending = false;
            if(data.length > 0){
              this.router.navigate(['/dam']);
            }else{
              this.router.navigate(['/login']);
            }
          });
        } else {
          this.router.navigate(['/login']);
        }
      }

      listWorkspace(){
        this.organisationService.getWorkspaceList().subscribe((data: any) => {
          this.showSending = false;
          if(data.length > 0){
            this.planUpgradeSection = false;
            this.hideFaq = false;
            this.paymentSuccessSection = false;
            this.socialLoginSection = false;
            this.tellUsMoreSection = false;
            this.signUpFormFilled = false;
            this.createWorkspaceSection = false;
            this.mainDetailSection = false;
            this.priceDetailsSection = true;
            this.headerSection = true;
            this.addUserCount = this.selectedMembership.allowed_seats;
            this.allowedInviteCount = this.selectedMembership.allowed_seats;
            this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
          }else{
            this.planUpgradeSection = false;
            this.hideFaq = false;
            this.paymentSuccessSection = false;
            this.socialLoginSection = false;
            this.tellUsMoreSection = false;
            this.signUpFormFilled = false;
            this.createWorkspaceSection = true;
            this.mainDetailSection = false;
            this.priceDetailsSection = false;
            this.headerSection = false;
          }
        });
      }

      createWorkspace(workspaceName: any){
        if(this.creatwWorkspace.valid) {
          this.showLeaveLoader = true;
          this.isShowCreateWorkspaceError = false;
          this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
            this.showLeaveLoader = false;
            this.creatwWorkspace.reset();
            this.planUpgradeSection = false;
            this.hideFaq = false;
            this.paymentSuccessSection = false;
            this.socialLoginSection = false;
            this.tellUsMoreSection = false;
            this.signUpFormFilled = false;
            this.createWorkspaceSection = false;
            this.mainDetailSection = false;
            this.priceDetailsSection = true;
            this.headerSection = true;
            this.addUserCount = this.selectedMembership.allowed_seats;
            this.allowedInviteCount = this.selectedMembership.allowed_seats;
            this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
          },
          (error) => {
            if(error.status == 403){
              this.showLeaveLoader = false;
              this.isShowCreateWorkspaceError = true;
              this.createWorkspaceErrorMessage = error.error.Message;
            } else {
              this.showLeaveLoader = false;
              this.isShowCreateWorkspaceError = true;
              this.createWorkspaceErrorMessage = error.error.Message;
            }
         });
        }
      }

      backToPricing() {
        this.planUpgradeSection = false;
        this.hideFaq = false;
        this.paymentSuccessSection = false;
        this.socialLoginSection = false;
        this.tellUsMoreSection = false;
        this.signUpFormFilled = false;
        this.createWorkspaceSection = false;
        this.mainDetailSection = true;
        this.priceDetailsSection = false;
        this.headerSection = true;
      }
}
